import DraftBadge, { useDraftSummaries } from '../DraftBadge';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import PlayerLayout from './PlayerLayout';
import PlayerNav from './PlayerNav';
import { fetchConversations } from '../store/conversationsSlice';

const stripHtml = html => (html || '').replace(/<[^>]*>/g, '').trim();

const PlayerInboxPage = () => {
  const draftSummaries = useDraftSummaries();
  const dispatch = useDispatch();
  const history = useHistory();
  const { list: conversations, loading } = useSelector(({ conversations: convState }) => convState);

  useEffect(() => {
    dispatch(fetchConversations());
  }, [dispatch]);

  if (loading) {
    return (
      <PlayerLayout>
        <PlayerNav />
        <div style={{ textAlign: 'center', padding: '40px', color: '#64748b' }}>
          Loading your messages...
        </div>
      </PlayerLayout>
    );
  }

  return (
    <PlayerLayout>
      <PlayerNav />
      <h1 style={{ fontSize: '22px', fontWeight: '700', color: '#1e293b', marginBottom: '24px' }}>
        Your Messages
      </h1>

      {conversations.length === 0 ? (
        <div
          style={{
            background: '#ffffff',
            border: '1px solid #e2e8f0',
            borderRadius: '8px',
            padding: '40px',
            textAlign: 'center',
            color: '#64748b',
          }}
        >
          <p style={{ fontSize: '16px', margin: 0 }}>No messages yet.</p>
          <p style={{ fontSize: '14px', marginTop: '8px' }}>
            When a coach contacts you, their message will appear here.
          </p>
        </div>
      ) : (
        <div style={{ background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '8px', overflow: 'hidden' }}>
          {conversations.map(conv => {
            const coach = conv.coachUserId;
            const isAssistantConversation = coach?.role === 'assistant';
            const isAdminConversation = coach?.role === 'admin';
            const coachName = coach
              ? `${coach.firstName} ${coach.lastName}`
              : 'Unknown Coach';
            const coachWithSchool = coach?.schoolName
              ? `${coachName} - <${coach.schoolName}>`
              : coachName;
            const displayName = isAssistantConversation ? 'agencja' : (isAdminConversation ? 'Kajetan Borecki' : coachWithSchool);
            const lastMsg = conv.lastMessage;
            const unread = conv.unreadCount || 0;
            const isUnread = unread > 0 || conv.markedUnreadByPlayer;
            const senderPrefix = lastMsg?.senderType === 'player' ? 'You: ' : '';

            return (
              <button
                key={conv._id}
                type="button"
                onClick={() => history.push(`/player/inbox/${conv._id}`)}
                style={{
                  background: isUnread ? '#e8f0fe' : '#ffffff',
                  border: 'none',
                  borderBottom: '1px solid #f1f5f9',
                  padding: '12px 16px',
                  cursor: 'pointer',
                  textAlign: 'left',
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                }}
              >
                {/* Unread dot */}
                <div style={{ width: '8px', flexShrink: 0 }}>
                  {isUnread && (
                    <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#2e496b' }} />
                  )}
                </div>
                {/* Sender name */}
                <span style={{ width: '180px', flexShrink: 1, minWidth: '80px', fontWeight: isUnread ? '700' : '500', fontSize: '14px', color: '#1e293b', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {displayName}
                </span>
                {/* Preview text */}
                <div style={{ flex: 1, minWidth: 0 }}>
                  <DraftBadge summaries={draftSummaries} threadType="conversations" conversationId={conv._id} />
                  {lastMsg && (
                    <span
                      style={{
                        fontSize: '13px',
                        color: isUnread ? '#334155' : '#94a3b8',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        display: 'block',
                        fontWeight: isUnread ? '600' : '400',
                      }}
                    >
                      {senderPrefix}
                      {stripHtml(lastMsg.text)}
                    </span>
                  )}
                </div>
                {/* Date + badge */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
                  {lastMsg && (
                    <span style={{ fontSize: '11px', color: '#94a3b8', whiteSpace: 'nowrap' }}>
                      {new Date(lastMsg.createdAt).toLocaleDateString([], { month: 'short', day: 'numeric' })}
                    </span>
                  )}
                  {isUnread && (
                    <span
                      style={{
                        background: '#2e496b',
                        color: '#ffffff',
                        borderRadius: '12px',
                        padding: '2px 8px',
                        fontSize: '11px',
                        fontWeight: '700',
                        minWidth: '20px',
                        textAlign: 'center',
                      }}
                    >
                      {unread > 0 ? unread : '●'}
                    </span>
                  )}
                </div>
              </button>
            );
          })}
        </div>
      )}
    </PlayerLayout>
  );
};

export default PlayerInboxPage;
